// =========================
// SIDE NAVIGATION COMPONENT
// =========================
// External Libraries
import { LitElement, html, css } from 'lit';

// App Modules
import Auth from '../Auth';
import { gotoRoute } from '../Router';

// This is the PopinSideNav class that handles the side navigation bar
// It includes methods for toggling the sidebar and rendering the menu items
class PopinSideNav extends LitElement {
  static get properties() {
    return {
      collapsed: { type: Boolean, reflect: true },
      user: { type: Object },
    };
  }

  constructor() {
    super();
    this.collapsed = true;
    this.user = Auth.currentUser;
  }

  // LIFECYCLE METHODS

  // This method is called when the component is first updated
  firstUpdated() {
    const waitForUser = setInterval(() => {
      if (Auth.currentUser?.role) {
        this.user = Auth.currentUser;
        clearInterval(waitForUser);
      }
    }, 50);
  }

  // EVENT HANDLERS

  // This method is called when the sidebar toggle button is clicked
  toggleSidebar() {
    this.collapsed = !this.collapsed;
  }

  render() {
    const isSupplier = this.user?.role === 'supplier';

    return html`
      <div class="nav">
        <img
          class="logo"
          src=${this.collapsed ? '/images/icon.svg' : '/images/logo.svg'}
          alt="PopIn logo"
        />

        <div class="menu-group">
          <div class="menu-item" @click=${() => gotoRoute('/feed')}>
            <sl-icon name="grid-1x2-fill"></sl-icon><span>Feed</span>
          </div>

          ${!isSupplier
            ? html`
                <div
                  class="menu-item"
                  @click=${() => gotoRoute('/createEvent')}
                >
                  <sl-icon name="calendar-plus-fill"></sl-icon
                  ><span>Create Event</span>
                </div>
                <div class="menu-item" @click=${() => gotoRoute('/friends')}>
                  <sl-icon name="people-fill"></sl-icon><span>Friends</span>
                </div>
              `
            : ''}

          <!-- <div class="menu-item" @click=${() => gotoRoute('/messages')}>
            <sl-icon name="chat-fill"></sl-icon><span>Messages</span>
          </div> -->
          <div class="menu-item" @click=${() => gotoRoute('/discoverEvents')}>
            <sl-icon name="calendar3"></sl-icon><span>Discover Events</span>
          </div>
          <div class="menu-item" @click=${() => gotoRoute('/marketplace')}>
            <sl-icon name="basket-fill"></sl-icon><span>Marketplace</span>
          </div>
        </div>

        <div class="bottom">
          <div class="menu-item" @click=${() => gotoRoute('/settings')}>
            <sl-icon name="gear-fill"></sl-icon><span>Settings</span>
          </div>
          <div class="menu-item" @click=${() => gotoRoute('/help')}>
            <sl-icon name="headphones"></sl-icon><span>Help</span>
          </div>
          <button
            class="toggle-btn"
            @click=${this.toggleSidebar}
            title="Toggle sidebar"
          >
            <sl-icon
              name=${this.collapsed
                ? 'arrow-right-circle'
                : 'arrow-left-circle'}
            ></sl-icon>
          </button>
        </div>
      </div>
    `;
  }

  static styles = css`
    :host {
      display: block;
      min-height: 100vh;
      max-height: 100vh;
      -webkit-overflow-scrolling: touch;
      background-image: linear-gradient(
        var(--sl-color-primary-600),
        var(--sl-color-primary-500)
      );
      color: white;
      width: var(--nav-width, 220px);
      transition: width 0.3s ease;
    }

    :host([collapsed]) {
      --nav-width: 85px;
    }

    .nav {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: left;
      flex-grow: 1;
      min-height: 90vh;
    }

    .logo {
      margin: 2rem auto;
      width: 60%;
    }

    :host([collapsed]) .logo {
      width: 45%;
    }

    .menu-group,
    .bottom {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }

    :host([collapsed]) .menu-group,
    :host([collapsed]) .bottom {
      padding-left: 0;
      align-items: center;
    }

    .menu-item {
      display: flex;
      align-items: center;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
      padding: 0.75rem 1rem;
      transition: all 0.3s ease;
    }

    .menu-item:hover {
      background-color: var(--sl-color-primary-700);
    }

    .menu-item sl-icon {
      margin-right: 1rem;
      font-size: 16px;
    }

    :host([collapsed]) .menu-item {
      justify-content: center;
      padding: 0.75rem 0rem;
      width: 100%;
    }

    :host([collapsed]) .menu-item sl-icon {
      margin-right: 0;
    }

    :host([collapsed]) .menu-item span {
      display: none;
    }

    .toggle-btn {
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      padding: 1rem 1rem 1rem 2.5rem;
      text-align: right;
    }

    :host([collapsed]) .toggle-btn {
      text-align: center;
      padding: 1rem 0rem;
      width: 100%;
    }

    .toggle-btn sl-icon {
      font-size: 1.3rem;
    }

    @media all and (max-width: 1366px) {
    }

    @media all and (max-width: 1024px) {
    }

    @media all and (max-width: 768px) {
      :host {
        position: absolute;
      }

      :host([collapsed]) {
        --nav-width: 50px;
      }
    }

    @media all and (max-width: 576px) {
    }
  `;
}

customElements.define('popin-side-nav', PopinSideNav);
